import {
    Card,
    CardHeader,
    CardContent,
    Stack,
} from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import StatBar from 'components/StatBar';


const TopUsersCard = ({ data = [], onUserClick }) => {
    if (!data.length) return null;

    return (
        <Card 
            sx={{ 
                height: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: 1, 
                border: `1px solid`,
                borderColor: "neutral.deep",
            }}
        >
            <CardHeader
                title="Top Users by Logs"
                subheader=""
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 2,
                    backgroundColor: "background.paper",
                    borderBottom: "1px solid",
                    borderColor: "divider",
                }}
            />
            <CardContent sx={{ overflowY: "auto", flex: 1 }}>
                <Stack spacing={1}>
                    {data?.map((u) => (
                        <StatBar
                            key={u.key}
                            icon={<PersonIcon fontSize="small" color="info" />}
                            label={u.label}
                            count={u.count}
                            percent={u.percent}
                            color="info.main"
                            onClick={() => onUserClick(u.key)}
                        />
                    ))}
                </Stack>
            </CardContent>            
        </Card>
    );
};

export default TopUsersCard;
